import React, { Component, useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { Layout, Responsive as ResponsiveGridLayout } from "react-grid-layout";
import { withSize } from "react-sizeme";
import { initialState } from "../../context/layout-context";
import TopBar from "./TopBar";
import Widget from "./Widget";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../context/store";
import { ComponentLayout } from "../../types";
import { find as _find } from "lodash";
import { Box } from "@mui/material";
import LayoutItem from "./LayoutItem";
import { useHistory, useParams } from "react-router-dom";
import { updateLayout } from "../../context/reducer/Layoutreducer";
import { setBreakPoint, setLayout } from "../../context/ActionType";
import { ApplicationContext, ProviderContext } from "../../ApplicationState";

var _ = require('lodash')

const rowHeights: { [key: string]: number } = { lg: 5, md: 3, sm: 2, xs: 1, xxs: 0 };
const cols = { lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 };
const breakpoints = {
    lg: 1200,
    md: 996,
    sm: 768,
    xs: 480,
    xxs: 0,
};

function DashboardContent() {
    const history = useHistory();

    const { providerState } = useContext(ProviderContext);
    const { userState } = useContext(ApplicationContext);

    let { id } = useParams<{ id: string }>();

    const state = useSelector((state: RootState) => state.layoutViewComponent);

    const [items, setItems] = useState(initialState.components);

    const dispatch: AppDispatch = useDispatch()

    const staticView = useMemo(
        () => state.views[0].componentLayout.map((layout) => ({ ...layout, static: false })),
        [state.views[0].componentLayout]
    );

    const draggableComponents = state.components;
    const windowSize = useRef([window.innerWidth, window.innerHeight]);

    const layoutstate = state.views[0]?.componentLayout || []; // Get layout from Redux

    // const [layout, setlayout] = useState<ComponentLayout[]>(
    //     state.views ? state.views[0].componentLayout : []
    // );

    const [layout, setlayout] = useState(layoutstate);


    const [component, setComponent] = useState<Component>();
    const [breakpt, setBreakpt] = useState(null)

    const mapLayout = useCallback(
        (currentLayout: ComponentLayout[], newLayout: Layout[]) => {
            return currentLayout.map((componentLayout) => {
                //console.log(newLayout);
                const found = _find(newLayout, ["i", componentLayout.i]);
                return { ...componentLayout, ...found };
            });
        },
        []
    );


    useEffect(() => {
        if (providerState.providerId) {
            // Fetch new layout or reload data for the selected provider
            const newLayout = getFromLS(userState.authenticatedUser.username + "_" + providerState.providerId, "layouts");

            if (newLayout) {
                setlayout(newLayout); // Update the dashboard layout
            } else {
                // If no saved layout, reset to default
                setlayout(initialState.views[0].componentLayout);
            }
        }
    }, [breakpt, layoutstate, providerState.providerId])

    // const [layouts, setLayouts] = useState(
    //     getFromLS("layouts") || initialState.views[0].componentLayout
    // );

    // const onLayoutChange = (_, allLayouts) => {
    //     setLayouts(allLayouts);
    //     saveToLS("layouts", allLayouts); // Save only after the state update
    // };

    const onLayoutSave = () => {
        saveToLS(userState.authenticatedUser.username + "_" + providerState.providerId, "layouts", layout);
        dispatch(
            updateLayout({
                views: [
                    {
                        componentLayout: layout,
                    },
                ],
            })
        );
        alert('Changes have been saved!')
    };

    // const onRemoveItem = useCallback((i: string) => {
    //     setlayout((prev) => prev.filter((l) => l.i !== i));
    // }, []);

    const compactType = null;

    const onLayoutChange = useCallback(
        (newLayout: Layout[]) => {
            setlayout((prev) => mapLayout(prev, newLayout));
        },
        [mapLayout]
    );


    // const onRemoveItem = (itemId) => {

    //     console.log("Before removing item:", items);
    //     console.log(itemId);
    //     //setItems(items.filter((i) => i !== itemId));
    //     //var newlayout = layout.filter((r)=> r.name !== itemId);
    //     console.log(items.filter((i) => i !== itemId));
    //     setLayouts(newlayout);
    //     dispatch(updateLayout({ ...state.views[0], componentLayout: layout }))
    //     console.log("After removing item:", items);
    //     //saveToLS("layouts", layouts);
    // };



    const onAddItem = (itemId) => {
        const checkedComponent = initialState.components[itemId - 1]
        const componentIndex = _.findIndex(initialState.views[0].componentLayout, ['component', checkedComponent])
        setlayout([initialState.views[0].componentLayout[componentIndex], ...layout])
    };

    const handleSave = useCallback(() => {
        if (state.views[0]) {

            dispatch(updateLayout({ ...state.views[0], componentLayout: layout }))
        }
    }, [dispatch, history, state.views, layout]);

    const onRemoveItem = useCallback((i: string) => {
        setlayout((prev) => {
            const updatedLayout = prev.filter((l) => l.i !== i);
            return updatedLayout;
        });

    }, []);

    const handleBreakPointChange = (breakpoint) => {
        setBreakpt(breakpoint)
    };

    const getLayout = () => {
        const savedLayouts = layout
        return savedLayouts
    }

    const originalLayoutfromLS = () => {
        // const savedLayouts = getFromLS(providerState.providerId, 'layouts')
        const savedLayouts = layout
        return savedLayouts
    }

    const getAllItems = () => {
        const items = JSON.parse(localStorage.getItem(providerState.providerId + "_" + userState.authenticatedUser.username))
        return items
    }

    return (
        <>
            <TopBar
                onLayoutSave={onLayoutSave}
                items={getLayout()}
                onRemoveItem={onRemoveItem}
                onAddItem={onAddItem}
                originalItems={originalLayoutfromLS()}
                allItems={getAllItems()}

            />
            <ResponsiveGridLayout
                className="react-grid-layout layout border"
                isDraggable
                isResizable
                draggableHandle=".grid-item__title"
                onBreakpointChange={handleBreakPointChange}
                cols={cols}
                isDroppable
                layouts={{ lg: layout }}
                breakpoints={breakpoints}
                compactType={"vertical"}
                onLayoutChange={onLayoutChange}
                isBounded={true}
                preventCollision={false}
                useCSSTransforms={false}
                width={window.innerWidth} // Dynamic width
            //onBreakpointChange={handleBreakPointChange}
            >
                {layout.map((componentLayout) => (
                    <div key={componentLayout.i} >
                        <Widget id={componentLayout.i} onRemoveItem={onRemoveItem} layout={componentLayout} render={setlayout} />
                    </div>
                ))}
            </ResponsiveGridLayout>
        </>
    );
}

export default withSize({ refreshMode: "debounce", refreshRate: 100 })(DashboardContent);

export function getFromLS(providerid, key) {

    let ls = {};
    if (global.localStorage) {
        try {
            ls = JSON.parse(global.localStorage.getItem(providerid)) || {};
        } catch (e) { }
    }
    return ls[key];
}

export function saveToLS(providerid, key, value) {
    if (global.localStorage) {
        global.localStorage.setItem(
            providerid,
            JSON.stringify({
                [key]: value
            })
        );
    }
}

